module.exports = __webpack_public_path__ + "img/439.6557346c.jpg";